export default __webpack_public_path__ + "static/media/UnsaveBatchProspects.9af8d6dd.svg";